module.exports = __webpack_public_path__ + "img/zip.3156d37a.png";